/* eslint-disable no-debugger */
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';
import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";

const postLscTouchpointData = (orgUnitId, touchpointObj, state, setState) => {
  if (touchpointObj) {
    const api = initApi(API_NAMES.COMMON, state, setState);
    const url = `/OrgUnit/${orgUnitId}/LscTouchpoint`;

    return api?.executeObject ? api.executeObject(url, 'POST', touchpointObj) : null;
  }
};

const putLscTouchpointData = (lscTouchpointId, touchpointObj, state, setState) => {
  if (lscTouchpointId > 0 && touchpointObj) {
    const api = initApi(API_NAMES.COMMON, state, setState);
    const url = `/OrgUnit/${lscTouchpointId}/LscTouchpoint`;

    return api?.executeObject ? api.executeObject(url, 'PUT', touchpointObj) : null;
  }
};  

const deleteLscTouchpointData = (lscTouchpointId, state, setState) => {
  if (lscTouchpointId > 0) {
    const api = initApi(API_NAMES.COMMON, state, setState);
    const url = `/OrgUnit/${lscTouchpointId}/LscTouchpoint`;

    return api?.executeObject ? api.executeObject(url, 'DELETE', null) : null;
  }
};

const LscTouchpointData = {
  INITIAL_STATE: BASIC_INITIAL_STATE,
  postLscTouchpointData,
  putLscTouchpointData,
  deleteLscTouchpointData
};

export default LscTouchpointData;
